module.exports = __webpack_public_path__ + "img/swiper1.cf24772b.png";